const auth = {
  verifyEmail: "/jsonindex/validate-temp-user-email",
  fetchLoginUser: "jsonuser/user-data",
  validateTempUserEmail: "/jsonindex/validate-temp-user-email",
  forgotMyPassword: "jsonindex/user-password?emailId=",
  validateActivationStatus: "/jsonindex/activation-status",
  fetchCountry: "/jsonindex/main?logParam=restrict",
  fetchCountryWithCommunity: "/jsonindex/main",
  sendVerificationCode: "/jsonindex/send-verification-code?redirectTenantId=",
  resendVerificationCode:
    "/jsonindex/resend-varification-code?emailType=Resend",
  createSixdigitcodeUser:
    "/jsonindex/six-digit-code-user?sixDigitCode={{sixDigitCode}}&sixDigitCodeStatus=approved",
  validateFBToken: "/jsonindex/getFBUser?accessToken=",
  facebookLogin: "/jsonindex/addFacebook?version=2",
  validateGoogleToken:
    "/jsonindex/gmail-mobile-app-url?oAuthCode={{googleToken}}",
  getUserData:
    "/jsonuser/land?redirectTenantId={{userTenantId}}&name={{userTenant}}",
  getTenantDetails: "/jsonindex/community-url?",
  fetchGmailContacts: "/gmail/redirect-gmail-contact-values",
};

const profile = {
  updateContactInfo: "/jsonuser/contact-profile",
  updateOptionalInfo: "/jsonuser/optional-profile",
  getUserAsks: "/jsonuser/more-activity-ask?breadCountLength=",
  getUserInvitations: "/jsonuser/more-activity-invitations?breadCountLength=",
  inviteFriend: "/jsonuser/invite-friend?",
  getPendingInvites: "/jsonuser/activity-receive-invitations?breadCountLength=",
  joinCommunity: "/jsonindex/community-url?tid=",
  getUserTags: "/jsonuser/more-activity-hash?",
  getUserUpdates: "/jsonuser/more-activity-announcements?",
  getProfileChildSays: "/jsonuser/child-says?",
  postProfileChildSays: "/jsonmessage/message-say-bottom?",
  getChildHashTag: "/jsonuser/child-q",
  getUserSays: "/jsonuser/user-activity-says?",
  getAnswerActivityData: "/jsonuser/user-activity-answers?",
  getReplyActivityData: "/jsonuser/user-activity-replies?",
  deleteProfilePost: "/jsonmessage/message-by-user",
  updateProfilePost: "/jsonmessage/update-message?",
  updateProfileInfo: "jsonuser/basic-profile",
  getProfile: "jsonuser/profile?profileimgerr=undefined",
  shareUnshareUpdate: "jsonuser/share-unshare?",
  updateProfilePic: "jsonuser/upload-profile-image",
  unfollowActivityTag: "/jsonmessage/unfollow-hash",
  getBlockedCommunities: "/jsonuser/get-blocked-communities",
  sendUnblockRequest: "jsonuser/unblock-user-community",
};

const feedData = {
  fetchFeedData: "/jsonmessage/all-feed",
  fetchUserSettings: "jsonuser/user-settings",
  fetchUserNames: "/jsonmessage/user-names/",
  fetchContributors: "/jsonuser/contribute",
  editPost: "/jsonmessage/update-message?",
  editBio: "/jsonuser/update-user-bio?shortBio=",
  tagSearch: "/jsonmessage/tag-search",
};

const emailActionsApis = {
  unsubscribe: "jsonuser/unsubscribe-mail?id=",
};

const invite = {
  inviteGmailContacts: "jsonuser/invite-friend",
  sendInvite: "/jsonuser/follow-private-hashtag",
  sendEmailInvite: "/jsonuser/invite-friend?inviteEmailId=",
  postMail: "/jsonuser/message-to-user",
  requestToFollow: "/jsonuser/private-community-follow",
};

const asksData = {
  fetchAsksData: "/jsonmessage/message-ask",
  fetchAsksSearchResultData: "/jsonmessage/success-ask-now",
  fetchAllAsks:
    "/jsonmessage/trending-items?task=asks&more=all&breadCountLength=",
  fetchTrendingAsks: "/jsonmessage/trending-items?task=asks",
};

const saysData = {
  fetchSaysData: "/jsonmessage/message-say-top",
  fetchAskListData: "/jsonmessage/success-say",
  fetchChildSaysData: "/jsonuser/child-says",
  postChildSayData: "/jsonmessage/message-say-bottom",
};

const tagsData = {
  fetchAllTags:
    "/jsonmessage/trending-items?task=tags&more=all&breadCountLength=",
  fetchTrendingTags: "/jsonmessage/trending-items?task=tags",
  fetchTagDetails:
    "jsonmessage/hash-list?limiter=one&tag=%23TredTest&opt=OPEN&hashCount=4&countPosition=hCount",
  fetchPrivateTagsData: "/jsonmessage/private-hash?",
  checkIfTagExists: "/jsonmessage/hash-check?",
  postNewTag: "/jsonmessage/post-tag?rtrValue=",
};

const notifications = {
  fetchNotifications: "/jsonuser/notifications",
  getNotificationStatus: "/jsonuser/notifications?viewstatus=read&&id=",
  removeNotification: "/jsonuser/notifications?edit=remove&&notiid=",
  unfollowNotification: "/jsonuser/notifications?edit=unfollow&&msgid=",
  showNotificationParentPost: "/jsonmessage/get-message-by-id?messageId=",
};

const searchData = {
  getSearchData: "/jsonmessage/h-search?startlimit=",
};

const attachment = {
  updateAttachment: "/jsonmessage/update-Doc",
  deleteAttachment: "/jsonmessage/document?messageID=",
};

const tagRatings = {
  giveTagRating: "/jsonmessage/rate-hashtag?",
  tagDownload: "/jsonmessage/tag-download?",
};

const moderator = {
  fetchModeratingCommunityList: "/jsonuser/moderating-Comm",
  makeAsModerator: "/jsonuser/moderator-request",
  getFollowingUsers: "/jsonuser/following-users",
  setModeratorPermission: "/jsonuser/restriction",
  scheduleNewsletter: "/jsonuser/newsletter-schedule",
  setCommunityType: "/jsonuser/community-type",
  updateTimelinePhotoDesc: "/jsonuser/timeline-photo-desc",
  submitBoundary: "/jsonuser/tenant-by-id",
  inviteFriend: "/jsonuser/invite-friend",
  inviteFriendThroughModerator: "/jsonuser/invite-friend",
  getModeratorActionItems: "/jsonuser/tid/",
  moderatorApproveDeny: "/jsonuser/moderator-approve-deny",
  primaryModeratorApproveDeny: "/jsonuser/primary-moderator-approve-deny?",
  fetchActivityLogData: "/jsonuser/report?",
  itemPostApproveDeny: "jsonuser/moderator-approve-deny",
  getModeratingCommunities: "/jsonuser/moderating-community?flag=myCommunities",
  uploadImages: "/jsonindex/upload-timeline-images",
  getMembersData: "/jsonuser/following-users?tenantId=",
  blockUser: "jsonuser/block-user-community",
  blockUserWithReason: "jsonuser/block-user-community",
  getBlockedUsers: "jsonuser/block-users",
  warnUser: "jsonuser/warn-user-community",
  fetchInviteMembersData: "jsonuser/invite-friend",
  inviteAsModerator: "jsonuser/add-remove-moderator",
  raiseModeratorRequest: "jsonuser/moderator-request",
  uploadCommunityImage:
    "/jsonindex/upload-cmt-image?tenantCacheUpdate=true&tenantId=",
};

const communities = {
  fetchNearByCommunities: "",
  changeCommunity: "/jsonuser/land?",
  viewActivityCommunity: "/jsonuser/land?",
  askYourCommunity: "/jsonmessage/open-question?messageId=",
  getCommunityMembers: "/jsonuser/members-of-community",
  getNearByUserCommunities: "/jsonuser/tenant-map?mapStatus=",
  getNearByCommunities: "/jsonuser/tenant-map?mapStatus=IndexNear",
  getNearByCommunitiesWithDefaulBlocked:
    "/jsonuser/tenant-map?mapStatus=defaultBlocked",
  getCommunitiesAfterSignIn: "/jsonuser/tenant-map",
  setDefaultTenant: "/jsonuser/default-tenant",
  followUnfollowCommunity: "/jsonuser/follow-community",
  fetchCountryList: "/jsonindex/main?logParam=search",
  communityCheck: "/jsonuser/community-check",
};
const Blog = {
  postBlog: "/jsonuser/create-post-blog",
  getCommunityBlog: "/jsonmessage/get-moderator-blog?",
  editAndRePostCurrentBlog: "/jsonuser/edit-delete-Blog",
  deleteCurrentBlog: "/jsonuser/edit-delete-Blog",
  fetchArchivedBlogs: "/jsonuser/edit-delete-Blog",
  deleteArchivedBlogs: "/jsonuser/edit-delete-Blog",
};
const NominateMember = {
  nominateUser: "/jsonuser/nominate-impact-member",
  checkNominationStatus: '/jsonuser/is-already-nominated?',
  getAllNominatedtedUserDetails: '/jsonuser/get-all-nomited-users',
  nominateOrRemoveImpactFullMembers: '/jsonuser/get-all-nomited-users',
  getAllImpactFUlMember: '/jsonuser/get-all-impactful-members?',
  getImpactfullMemberActivityLog: '/jsonuser/get-all-impactful-members-action?'
};
const follows = {
  fetchFollowUnfollowData: "/jsonmessage/follow-unfollow",
  // fetchFollowUnfollowAskData: '/jsonuser/q-follows',
  fetchFollowerCount: "/jsonuser/message-id/",
};

const votes = {
  fetchVoteUpStatus: "/jsonmessage/vote-up?",
};

const updatesData = {
  editUpdate: "/jsonuser/announcements?",
  checkIfContainsTag: "/user/hashFind.html?",
  postNewUpdate: "/jsonuser/post-on-multi-community?",
};

const posts = {
  getReportPostStatus: "/jsonuser/report-abuse-status",
  reportPost: "/jsonuser/report-abuse",
  deleteMessage: "/jsonmessage/message-by-user",
  deleteAskTagPostUnderSayActivity: "/jsonmessage/message-by-user",
  getActivityPostCount: "jsonuser/activity",
};

const community = {
  followCommunity: "/jsonuser/follow-community",
  updateDefaultTenant: "/jsonuser/default-tenant",
  getCommunity: "/jsonuser/community",
  getTenantList: "/jsonuser/tenant-list",
  createNewCommunity: "/jsonindex/new-community",
  communityRequestData: "/jsonindex/community-approve",
  newCommunityModeratorRequest: "/jsonuser/approved-by-admin",
  approveOrRejectNewCommunityRequest: "/jsonindex/approve-community-status?",
  isNewCommunityRequest: `/jsonuser/invite-new-comminity?`,
};

const settings = {
  updateUserSettings: "/jsonuser/notification",
  updatePassword: "/jsonuser/pass-profile",
  getTimeLineImages: "/jsonuser/timeline-images",
};

const footer = {
  postContact: "/jsonuser/user-survey",
};

const activity = {
  fetchImages: "/jsonindex/main?logParam=restrict",
  fetchActivityFeed: "/jsonmessage/all-feed?",
  fetchActivityAsks: "/jsonmessage/trending-items?",
  fetchActivityTags: "/jsonmessage/trending-items?",
  fetchActivityChildSays: "/jsonuser/child-says",
  fetchActivity: "jsonuser/activity",
  editMessageActivityChildQ: "jsonmessage/update-message?",
};

const timeline = {
  deleteTimeLineImage: "jsonuser/timeline-images",
  updateCommunityInfo: "jsonuser/tenant-by-id",
};

const privateTags = {
  deletePrivateTag: "jsonmessage/message-by-user",
  editPrivateTag: "jsonmessage/update-message",
};

const appleUrls = {
  signUp: "jsonindex/apple-id",
};

export {
  auth,
  profile,
  emailActionsApis,
  invite,
  feedData,
  asksData,
  saysData,
  tagsData,
  notifications,
  searchData,
  attachment,
  tagRatings,
  moderator,
  communities,
  Blog,
  NominateMember,
  follows,
  votes,
  updatesData,
  posts,
  community,
  settings,
  footer,
  activity,
  timeline,
  privateTags,
  appleUrls,
};
